import { PlannerSkillsList } from "routes/plan/plugins/weekly-planner/plugins/planner-skills-schedule/planner-skills-list"
import { PlannerDetails } from "routes/plan/planner-details"

PlannerDetails("skills").plug(<PlannerSkillsList />)
